import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

// default empty state
let state = {
    loading: true,
    token: '',
    request: {},
    quote: {},
    travel: {},
}

// state from browser local storage
let localstorage_state = JSON.parse( Vue.localStorage.get(process.env.VUE_APP_STORE_KEY) )
if(localstorage_state) {
    Object.keys(localstorage_state).forEach(e => {
            if(localstorage_state[e] && localstorage_state[e] != null) {
                state[e] = localstorage_state[e]
            }
        }
    )
}

export default new Vuex.Store({
    state: state,
    getters: {
        get_loading(state)
        {
            return state.loading
        },
        get_token(state)
        {
            return state.token
        },
        get_request(state)
        {
            return state.request
        },
        get_quote(state)
        {
            return state.quote
        },
        get_travel(state)
        {
            return state.travel
        },
    },
    // mutations -> operazioni SINCRONE (triggerate da .commit())
    mutations: {
        set_loading(state,payload)
        {
            state.loading = payload
        },
        set_token(state,payload)
        {
            state.token = payload.token
        },
        set_request(state,payload)
        {
            state.request = payload.request
        },
        set_quote(state,payload)
        {
            state.quote = payload.quote
        },
        set_travel(state,payload)
        {
            state.travel = payload.travel
        },
    },
    // actions -> operazioni ASINCRONE che lanciano mutations (triggerate da .dispatch())
    actions: {
        // toggle(context, payload) {
        //     context.commit('toggle', payload);
        // }
    },
    modules: {
        //otherStoreModule: otherStoreModule
    }
})